import React from "react";
import { useT } from "@/context/LanguageContext";

export default function Marquee({ words = [] }) {
  const { t } = useT();
  const items = (words.length ? words : [
    { en: "Clean spaces", es: "Espacios limpios" },
    { en: "Better lives", es: "Vidas mejores" },
  ]).map(t);
  const doubled = [...items, ...items, ...items, ...items];

  return (
    <section
      className="relative bg-[color:var(--gcs-emerald)] text-[color:var(--gcs-ivory)] py-8 md:py-10 overflow-hidden with-grain"
      data-testid="marquee-section"
    >
      <div className="marquee-track">
        {doubled.map((w, i) => (
          <span key={i} className="flex items-center gap-8 md:gap-14 px-6 md:px-10 font-serif italic text-[38px] md:text-[64px] leading-none">
            <span className="text-[color:var(--gcs-ivory)]">{w}</span>
            <span className="inline-block h-2 w-2 rounded-full bg-[color:var(--gcs-gold)]" />
          </span>
        ))}
      </div>
    </section>
  );
}
